import { FilterParamsToFilterUi } from '@/components/Order/OrdersDetail/Filters/mapper';
import cacheKeys from '@/data/api/cacheKeys';
import { getDetailOrders } from '@/data/api/request/orderDetailRequests';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';

export function useGetDetailOrders(args: { page?: number }) {
  const [searchParams, _] = useSearchParams();

  const filterUi = FilterParamsToFilterUi(searchParams);

  const orderId = filterUi.orderId.trim();
  let dateRange: [string, string] | undefined;
  if (filterUi.startDate && filterUi.endDate) {
    dateRange = [
      dayjs(filterUi.startDate).format('YYYY-MM-DD'),
      dayjs(filterUi.endDate).format('YYYY-MM-DD'),
    ];
  }
  const sellerIds = filterUi.sellers.map((seller) => seller.sellerId);
  const statusId = filterUi.selectedStatusId.trim();
  const remissionStatusId = filterUi.remissionStatusId.trim();
  const kamIds = filterUi.selectedKamIds;

  const { data, error, isLoading } = useQuery({
    queryKey: [
      cacheKeys.detailOrder.list,
      {
        page: args.page,
        orderId,
        dateRange,
        sellerIds,
        statusId,
        remissionStatusId,
        kamIds,
      },
    ],
    queryFn: () =>
      getDetailOrders({
        pageNumber: args.page,
        orderNumber: orderId,
        deliveryDateRange: dateRange,
        sellerIds,
        statusId,
        remissionStatusId: remissionStatusId ?? undefined,
        kamIds,
      }),
  });

  return {
    data,
    error,
    isLoading,
  };
}
